import { render, staticRenderFns } from "./AdminSettingsSelect.vue?vue&type=template&id=5ced4a39&scoped=true"
import script from "./AdminSettingsSelect.vue?vue&type=script&lang=js"
export * from "./AdminSettingsSelect.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsSelect.vue?vue&type=style&index=0&id=5ced4a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced4a39",
  null
  
)

export default component.exports